export default __webpack_public_path__ + "static/media/matchmaker-chevron.2a8b6063.svg";